/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import * as Datetime from 'react-datetime';
import {Moment} from 'moment';

import {getDisplayText} from './commons';
import {
    EntityAttribute,
    EntityAttributeProps,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
} from './EntityAttribute';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';

import './css/react-datetime.css';

/**
 * The default props for a string entity attribute
 */
export const DATE_ENTITY_ATTRIBUTE_DEFAULT_PROPS = {
    ...ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    onFieldInputEnded: (component: EntityAttribute, input: string) => {
        if (
            input.length === 0 &&
            !component.props.isRequired(component.props.attribute)
        ) {
            // the new value is empty and not required
            // => convert to unset value
            return component.props.onFieldEditedValue(component, null);
        }
        component.props.onFieldEditedValue(component, input);
    },
    renderInput: (component: EntityAttribute) => {
        const onChange = (newDate: Moment) => {
            if (newDate) {
                component.props.onFieldInputEnded(
                    component,
                    newDate.format('YYYY/MM/DD HH:mm:ss')
                );
                return;
            }
        };
        const datetimeProps: Datetime.DatetimepickerProps = {
            inputProps: {placeholder: 'N/A'},
            onChange,
            onBlur: onChange,
            dateFormat: 'DD/MM/YYYY',
            timeFormat: 'HH:mm',
        };
        if (component.state.value !== null) {
            datetimeProps.value = new Date(
                getDisplayText(component.state.value)
            );
        }

        return <Datetime {...datetimeProps} />;
    },
};

/**
 * Component for rendering a string entity attribute
 */
export class DateEntityAttribute extends React.Component<EntityAttributeProps> {
    public static defaultProps = DATE_ENTITY_ATTRIBUTE_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
